import React, { useEffect, useState } from 'react';

import ReactTable from '../components/ReactTable';
import { useBeneficiariesCols } from '../hooks/EmployeeCols';
import fetchFromAthena from '../functions/FetchFromAthena'

export default function Beneficiaries(props) {
    const beneficiariesCols = useBeneficiariesCols();
    const [state,setState] = useState({
        data: [],
        isLoading: true
    })

    useEffect(() => {
        getBeneficiaries()
    },[])

    useEffect(() => {
        if (props.empId && props.company) {
            setState(prevState => ({
                ...prevState,
                isLoading: true
            }))
            getBeneficiaries()
        }
    }, [props.empId, props.company])

    const getBeneficiaries = async() => {
        const queries = ['employee_beneficiary_read']

      const data = await Promise.allSettled(
        queries.map(query =>
          fetchFromAthena({
            queryName: query,
            headers: {
              company: props.company,
              empId: props.empId
            },
            accessToken: props.credentials.user.accessToken,
            credentials: props.credentials
          })
        )
      ).then(results => {
        return results
      })
      
      setState({
        isLoading: false,
        data: data[0].value
      })
    }
      return <ReactTable isLoading={state.isLoading} cols={beneficiariesCols} data={state.data} />;
}
